
import { GridEditState, ScaleBorder } from "@/utils/grid/grid-edit-state";
import { GridItem } from "@/utils/grid/grid-item";
import Vue from "vue";
export default Vue.extend({
	data(){
		return {
			currentRect: {
				top: 0,
				left: 0,
				width: 0,
				height: 0
			},
			wasAnimatedBefore: false
		};
	},
	props: {
		item: {
			type: Object as ()=>GridItem,
			required: true
		},
		state: {
			type: Object as()=>GridEditState,
			required: true
		}
	},
	computed: {
		style():any{
			if (this.state.ignoreHorizontalOnMobile && this.$wf.isSmDown){
				return {
					gridRow: `${this.item.singleColPosition+1} / span ${this.item.height}`,
					gridColumn: `1 / span 1`
				};
			}
			return {
				gridColumn: `${this.item.col+1} / span ${this.item.width}`,
				gridRow: `${this.item.row+1} / span ${this.item.height}`
			};
		},
		editMode():boolean {
			return this.state.editMode;
		},
	},
	watch: {
		editMode: {
			immediate: true,
			handler(){
				this.onStoreRect();
			}
		}
	},
	methods: {
		onDragStart(event:MouseEvent){
			this.state.setDragItem(this.item);
		},
		onMouseUp(event:MouseEvent){
			if (this.state.isDraggingItem(this.item)){
				this.state.resetDragItem();
			}
			if (this.state.isScalingItem(this.item)){
				this.state.resetScaleItem();
			}
		},
		onScaleRightStart(){
			this.state.onScaleStart(this.item, ScaleBorder.RIGHT);
		},
		onScaleLeftStart(){
			this.state.onScaleStart(this.item, ScaleBorder.LEFT);
		},
		onScaleBottomStart(){
			this.state.onScaleStart(this.item, ScaleBorder.BOTTOM);
		},
		onScaleTopStart(){
			this.state.onScaleStart(this.item, ScaleBorder.TOP);
		},
		onStoreRect(){
			this.currentRect = this.getRect();
		},
		getRect(){
			let el = (this.$el as HTMLElement);
			if (!el) return{
				top: 0,
				left: 0,
				width: 0,
				height: 0
			};
			return {
				top: el.offsetTop,
				left: el.offsetLeft,
				width: el.offsetWidth,
				height: el.offsetHeight
			};
		},
		async onTransition(){
			let rect = this.getRect();
			if (rect.height == this.currentRect.height && rect.width == this.currentRect.width && rect.top == this.currentRect.top && rect.left == this.currentRect.left){
				return;
			}

			let el = (this.$el as HTMLElement);
			if (!el) return;
			if (!el.animate) return;
			if (!this.wasAnimatedBefore) {
				this.wasAnimatedBefore = true;
				return;
			}

			let deltaX = this.currentRect.left - rect.left;
			let deltaY = this.currentRect.top - rect.top;
			let deltaW = this.currentRect.width / rect.width;
			let deltaH = this.currentRect.height / rect.height;

			el.animate([{
					transformOrigin: "top left",
					transform: `translate(${deltaX}px, ${deltaY}px) scale(${deltaW}, ${deltaH})`
				}, {
					transformOrigin: "top left",
					transform: "none"
				}],
				{
					duration: 200,
					easing: "ease-in-out",
					fill: "both"
				});

			this.currentRect = rect;
		}
	},
	created(){
		window.addEventListener("mouseup", this.onMouseUp);
		this.state.on("store-rects", this.onStoreRect);
		this.state.on("transition", this.onTransition);
	},
	destroyed(){
		window.removeEventListener("mouseup", this.onMouseUp);
		this.state.off("store-rects", this.onStoreRect);
		this.state.off("transition", this.onTransition);
	}
});
